import React, { useState } from 'react';
import { useError } from '../contexts/ErrorContext';
import './ErrorNotification.css';

const ErrorNotification = () => {
  const { errors, removeError, clearAllErrors, hasErrors } = useError();
  const [isExpanded, setIsExpanded] = useState(false);

  const formatTime = (date) => {
    return date.toLocaleTimeString();
  };

  return (
    <div className="error-notification-container">
      <button
        className="error-notification-bell"
        onClick={() => setIsExpanded(!isExpanded)}
        aria-label={isExpanded ? 'Collapse errors' : 'Expand errors'}
        title={hasErrors ? `${errors.length} error${errors.length !== 1 ? 's' : ''}` : 'No errors'}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
        {errors.length > 0 && (
          <span className="error-count-badge">{errors.length}</span>
        )}
      </button>

      {isExpanded && (
        <div className="error-notification-panel">
          <div className="error-notification-header">
            <h3>Errors ({errors.length})</h3>
            <button
              className="error-clear-button"
              onClick={clearAllErrors}
              title="Clear all errors"
            >
              Clear All
            </button>
          </div>
          <div className="error-list">
            {errors.length === 0 ? (
              <div className="error-empty">No errors</div>
            ) : (
              errors.map((error) => (
                <div key={error.id} className="error-item">
                  <div className="error-item-header">
                    <span className="error-source">{error.source}</span>
                    <span className="error-time">{formatTime(error.timestamp)}</span>
                    <button
                      className="error-remove-button"
                      onClick={() => removeError(error.id)}
                      title="Remove error"
                    >
                      ×
                    </button>
                  </div>
                  <div className="error-message">{error.message}</div>
                  {error.details && (
                    <div className="error-details">{error.details}</div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ErrorNotification;
